var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home-layout"},[_c('layout-header',{attrs:{"floating":true,"transparent":true}}),_vm._t("default"),_c('layout-footer')],2)}
var staticRenderFns = []

export { render, staticRenderFns }